import { Component, computed, Signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'admin-footer',
  imports: [

  ],
  host: {
    class: 'flex w-full flex-auto flex-col',
  },
  templateUrl: './footer.html',
})
export class AdminFooter {

  currentYear: Signal<number> = computed(() => {
    return (new Date()).getFullYear()
  }) 
}
